module.exports = __webpack_public_path__ + "static/media/Synthetic_Lethality.8b2d43bd.svg";